const environmentConstants = {
  ROOT_URL: process.env.REACT_APP_API_ENDPOINT,
  APP_URL: process.env.REACT_APP_ROOT_URL,
  PUBLIC_KEY: process.env.REACT_APP_PUBLIC_KEY,
  JWT_ALGORITHM: process.env.REACT_APP_JWT_ALGORITHM,
  EMAIL_REGEX: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,5})+$/,
};

export default environmentConstants;
